import styled from 'styled-components'
import { Typography } from '@telavita-core/react-design-kit'
interface ButtonTextProps {
  isMobile: boolean
}

export const Header = styled.header`
  display: flex;
  flex-direction: column;
  padding: 15px 20px;
  border-bottom: 1px solid #e2e2e2;
`

export const Label = styled.span`
  text-transform: uppercase;
  font-size: 10px;
  color: #898989;
`

export const Button = styled.button`
  display: flex;
  align-items: center;
  background: transparent;
  border: initial;
  font-size: 16px;
  padding: 0;
`

export const ButtonText = styled(Typography)<ButtonTextProps>`
  font-size: 15px;
  color: #4b4b4b;
`

export const OptionsContainer = styled.ul`
  display: flex;
  align-items: flex-start;
  padding: 0;
  flex-direction: column;
  overflow: hidden;
  margin: 0;

  li:last-child {
    border-radius: 0 0 5px 5px;
  }
`